import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {tap} from 'rxjs/operators';

export const standarizeErrorsInterceptor: HttpInterceptorFn = (req, next) => {
  // Se podria manejar la peticion en esta seccion mediante el 'req'

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event.type === 4) { // HttpResponse
          const response = event as any; // Necesario por el tipo
          const body = response.body;

          // Verificar si el cuerpo contiene un código de error
          const errorCode = detectErrorCode(body);

          if (errorCode) {
            // Convertir en error
            throw new HttpErrorResponse({
              error: body,
              status: errorCode,
              statusText: 'Error in response body',
              url: req.url
            });
          }
        }
      },
      error: (err) => {
        // Añadir propiedad personalizada
        (err as any).error.message = getUserMessage(err);
      }
    })
  );
};

// Función para detectar códigos de error en el cuerpo de la respuesta
function detectErrorCode(body: any): number | null {
  if (!body) return null;

  // Buscar posibles campos que contengan el código de error
  const possibleFields = ['statusCode', 'status', 'code', 'errorCode'];

  for (const field of possibleFields) {
    if (body[field]) {
      const value = body[field].toString();

      // Verificar si es un código 4xx/5xx
      if (value.startsWith('4') || value.startsWith('5')) {
        return parseInt(value, 10);
      }
    }
  }

  // Caso especial: success === false
  if (body.success === false && body.statusCode) {
    return parseInt(body.statusCode.toString(), 10);
  }

  return null;
}

// Función para crear mensajes de usuario amigables
function getUserMessage(error: HttpErrorResponse): string {

  const validationMsg = error.error.validationErrors ? error.error.validationErrors[0].reason : null;

  if (validationMsg) return validationMsg;

  // Mensajes genéricos basados en el código de estado
  switch (error.status) {
    case 0: return 'No se pudo conectar al servidor';
    case 400: return 'Solicitud inválida';
    case 401: return 'No autorizado';
    case 403: return 'Acceso prohibido';
    case 404: return 'Recurso no encontrado';
    case 500: return 'Error interno del servidor';
    default: return `Error inesperado (${error.status})`;
  }
}
